import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { useCourier } from '../../context/CourierContext';

const CourierRoute = ({ children }) => {
  const { courierUser, courierLoading } = useCourier();
  const location = useLocation();

  if (courierLoading) {
    return <LoadingSpinner fullScreen message="Checking courier access..." />;
  }

  if (!courierUser) {
    return <Navigate to="/courier-login" state={{ from: location }} replace />;
  }

  return children;
};

export default CourierRoute;
